import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllClasses as apiFn } from "../../api/apiClasses";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllClasses() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: deleteAllClasses, isPending: isDelete } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["classes"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { deleteAllClasses, isDelete };
}
